"use client";

import { useEffect } from "react";
type MaybeArray<T> = T | T[];
// Hook to detect outside click for one or more refs
export const useOutsideClick = (
    refs: MaybeArray<React.RefObject<HTMLElement | null>>,
    callback: () => void
) => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent | TouchEvent) => {
            const refsArray = Array.isArray(refs) ? refs : [refs];

            const clickedOutside = refsArray.every(
                (ref) => ref.current && !ref.current.contains(event.target as Node)
            );

            if (clickedOutside) {
                callback();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [refs, callback]);
};
